import React from 'react';

import { Box, Grid, Typography } from '@mui/material';

const ArrayDiffFieldLayout = ({
  label,
  removedElement,
  addedElement,
  size = {
    xs: 12,
    md: 6,
    xl: 3,
  },
  width,
}: {
  label: string;
  removedElement?: React.ReactNode;
  addedElement?: React.ReactNode;
  size?: {
    xs?: number;
    md?: number;
    xl?: number;
  };
  width?: string;
}) => {
  if (!removedElement && !addedElement) return null;

  return (
    <Grid
      size={size}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="mediumTitle">{label}</Typography>
        <Box display="flex" flexDirection="row" gap={15}>
          {removedElement && (
            <Box width={width} display="flex" flexDirection="column">
              <Typography variant="smallTitle">Removed</Typography>
              {removedElement}
            </Box>
          )}
          {addedElement && (
            <Box width={width} display="flex" flexDirection="column">
              <Typography variant="smallTitle">Added</Typography>
              {addedElement}
            </Box>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default ArrayDiffFieldLayout;
